/**
 * Длительность для игрока: «2 мин 50 сек», «1 ч 30 мин», «1.5 сек», «800 мс».
 *
 * Без дробных минут: «2.8 мин» читается как 2 мин 8 сек, а это 2 мин 50 сек.
 * Дробь остаётся только у коротких значений (меньше 10 сек) — у каста важны десятые.
 * Нулевые части опускаются: 120 сек → «2 мин», 7200 сек → «2 ч».
 *
 * Подписи — `wiki:timeUnits.*`, ключи с неймспейсом, поэтому годится `t` любого `useTranslation`.
 */
export const formatDuration = (seconds: number, t: (key: string) => string): string => {
  if (seconds < 1) return `${Math.round(seconds * 1000)} ${t('wiki:timeUnits.milliseconds')}`;

  if (seconds < 10) {
    const rounded = Math.round(seconds * 10) / 10;
    // 9.96 округлится до 10 — это уже целые секунды, ниже
    if (rounded < 10) return `${rounded} ${t('wiki:timeUnits.seconds')}`;
  }

  const total = Math.round(seconds);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;

  const parts: string[] = [];
  if (hours > 0) parts.push(`${hours} ${t('wiki:timeUnits.hours')}`);
  if (minutes > 0) parts.push(`${minutes} ${t('wiki:timeUnits.minutes')}`);
  if (secs > 0) parts.push(`${secs} ${t('wiki:timeUnits.seconds')}`);
  return parts.join(' ');
};
